import { getExt } from '@ps/utils/game'
import { AssetType } from '@ps/utils/config'
import { Base64 } from 'js-base64'
import { getFileName } from '@com/utils/file'
import { generateImageName } from '@ps/views/workbench/resource-manager/resource'
import SparkMD5 from 'spark-md5'
import { cookImageBinContent } from '@ps/bridge/qc/bin/index'
import { removeBase64Prefix } from '@com/utils/base64'

/**
 * 创建图片节点物料
 */
export const createImageComponent = ({
  file,
  // name 必须要有文件扩展名
  name,
  resourcePath,
}: {
  file: File
  name?: string
  resourcePath: string
}): Promise<{
  type: number
  name: string
  files: {
    name: string
    data: string
  }[]
}> => {
  return new Promise((resolve, reject) => {
    const reader: FileReader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = async () => {
      // 上传图片节点的图片时使用 md5 前 10 个字符作为文件名后缀，保证同一张图片不会存储多次
      // 为什么不是用 md5 所有字段，因为长度过长，在同一个包中使用前 10 个应该就可以满足需求了
      const md5 = SparkMD5.hash(reader.result as string).substr(0, 10)
      const newFileName = `${generateImageName(md5)}.${getExt(
        name || file.name,
      )}`
      const fileName = getFileName((newFileName || file.name).toLowerCase())
      // 转换为 bin 格式后上传
      const { binName, binContent } = cookImageBinContent({
        name: fileName,
        resourcePath,
      })
      resolve({
        type: AssetType.ASSET_ATLAS,
        name: fileName,
        files: [
          // bin
          {
            name: binName.toLowerCase(),
            data: Base64.encode(binContent),
          },
          // 原图
          {
            // 非浏览器使用的格式转成合法的 base64
            data: removeBase64Prefix(reader.result as string),
            name: fileName,
          },
        ],
      })
    }

    reader.onerror = (e) => {
      console.log(e)
      reader.abort()
      reject('创建图片组件发生错误')
    }
  })
}
